import {useCallback} from "react";
import {getSubmit, postSubmit} from "@ui-seeker/utils";

import {BACKEND_APIS} from "@constants";
import {isLoadMoreItems, matcherSKUsItems} from "../@signals";


export default function useMatchersSKUsItems() {

	const handleSubmit = useCallback(() => {
		isLoadMoreItems.value = true
		getSubmit(`${BACKEND_APIS.MATCHERS}/skus/load-items`).then(({ items }) => {
			matcherSKUsItems.value = [...(matcherSKUsItems.value || []), ...items]
			isLoadMoreItems.value = false
			saveInCache(items)
		}).catch(() => isLoadMoreItems.value = false)
	}, [])

	const saveInCache = useCallback(items => {
		postSubmit(`${BACKEND_APIS.MATCHERS}/skus/saved-in-cache`, {
			items
		}).catch(() => console.error('ERROR SAVE IN CACHE'))
	}, [])

	const handleMoreProducts = useCallback(() => {
		matcherSKUsItems.value = null
		postSubmit(`${BACKEND_APIS.MATCHERS}/skus/disabled-filters`).then(() => {
			handleSubmit()
		}).catch(() => matcherSKUsItems.value = [])
	}, [])


	return {
		handleSubmit,
		handleMoreProducts
	}
}